import { showDialog } from '../../dialog/index';
import Logger from '../../../services/Logger';
import sdk from '../../../sdk/index';
import * as utils from '../../../shared/utils';
import l18n from '../../../shared/strings';
import Toast from '../../Toast';
import UiBlocker from '../../../services/UiBlocker';
import picsioConfig from '../../../../../../config';

const handleSuggestImprovement = () => {
  Logger.log('User', 'SuggestImproveIconClicked', { initiation_location: window && window.location.pathname });
  const savedText = utils.LocalStorage.get('picsio.suggestImprovementText') || '';
  showDialog({
    title: l18n.DIALOGS.SUGGEST_IMPROVEMENT.TITLE,
    text: l18n.DIALOGS.SUGGEST_IMPROVEMENT.TEXT,
    textarea: {
      placeholder: picsioConfig.isPim ? l18n.DIALOGS.SUGGEST_IMPROVEMENT.PLACEHOLDER_TORIUT : l18n.DIALOGS.SUGGEST_IMPROVEMENT.PLACEHOLDER,
      value: savedText,
      onChange: (e, value) => {
        utils.LocalStorage.set('picsio.suggestImprovementText', value);
      },
    },
    textBtnOk: l18n.DIALOGS.SUGGEST_IMPROVEMENT.BTN_OK,
    textBtnCancel: l18n.DIALOGS.SUGGEST_IMPROVEMENT.BTN_CANCEL,
    onOk: async ({ textarea }) => {
      if (textarea) {
        try {
          UiBlocker.block();
          await sdk.axiosInstance.post('/contact/improvement', { text: textarea });
          Logger.log('User', 'SuggestImproveModalSentClicked');
          utils.LocalStorage.remove('picsio.suggestImprovementText');
          Toast(l18n.TOAST.SUCCESS_SEND_SUGGESTION_FOR_IMPROVEMENT, {
            autoClose: false,
            type: 'success',
          });
        } catch (error) {
          Logger.error(new Error('Cannot send suggestion for improvement'), { error }, [
            'SuggestImprovementDialogSend',
            { errorMessage: (error && error.message) || 'NoMessage' },
          ]);
          Toast(l18n.TOAST.ERROR_SEND_SUGGESTION_FOR_IMPROVEMENT, {
            autoClose: false,
            type: 'error',
          });
        } finally {
          UiBlocker.unblock();
        }
      }
    },
    onCancel: () => {
      Logger.log('User', 'SuggestImproveModalClosed');
    },
  });
  Logger.log('User', 'SuggestImproveModalShown');
};

export default handleSuggestImprovement;
